import React from 'react';

function OutsidePitchingNotice() {
    return (
        <div className="alert alert-info text-body text-center">
            <span className="fw-bold">
                Note: Qwoted will never share your email address for pitching outside our platform.
            </span>
            <br />
            If you receive a pitch directly in your email, forward it to <a href="mailto:reportprspam@qwoted.com">reportprspam@qwoted.com</a>.
        </div>
    );
}

export default OutsidePitchingNotice;
